export const listCountries = [
  {
    iso3: 'ABW',
    country: 'Aruba',
    countryToSave: 'Aruba',
    ddi: '297',
    iso2: 'AW',
    citizenship: '',
    name: 'Aruba',
  },
  {
    iso3: 'AFG',
    country: 'Afeganistão',
    countryToSave: 'Afghanistan',
    ddi: '93',
    iso2: 'AF',
    citizenship: 'Afghani',
    name: 'Afeganistão',
  },
  {
    iso3: 'AGO',
    country: 'Angola',
    countryToSave: 'Angola',
    ddi: '244',
    iso2: 'AO',
    citizenship: 'Angolan',
    name: 'Angola',
  },
  {
    iso3: 'AIA',
    country: 'Anguilla',
    countryToSave: 'Anguilla',
    ddi: '1',
    iso2: 'AI',
    citizenship: '',
    name: 'Anguilla',
  },
  {
    iso3: 'ALA',
    country: 'Ilhas Åland',
    countryToSave: 'Ilhas Åland',
    ddi: '358',
    iso2: 'AX',
    citizenship: '',
    name: 'Ilhas Åland',
  },
  {
    iso3: 'ALB',
    country: 'Albânia',
    countryToSave: 'Albânia',
    ddi: '355',
    iso2: 'AL',
    citizenship: 'Albany',
    name: 'Albânia',
  },
  {
    iso3: 'AND',
    country: 'Andorra',
    countryToSave: 'Andorra',
    ddi: '376',
    iso2: 'AD',
    citizenship: '',
    name: 'Andorra',
  },
  {
    iso3: 'ARE',
    country: 'Emirados Árabes Unidos',
    countryToSave: 'United Arab Emirates',
    ddi: '971',
    iso2: 'AE',
    citizenship: 'EAE (United Arab Emirates)',
    name: 'Emirados Árabes Unidos',
  },
  {
    iso3: 'ARG',
    country: 'Argentina',
    countryToSave: 'Argentina',
    ddi: '54',
    iso2: 'AR',
    citizenship: 'Argentine',
    name: 'Argentina',
  },
  {
    iso3: 'ARM',
    country: 'Armênia',
    countryToSave: 'Armenia',
    ddi: '374',
    iso2: 'AM',
    citizenship: 'Armenian',
    name: 'Armênia',
  },
  {
    iso3: 'ASM',
    country: 'Samoa Americana',
    countryToSave: 'American Samoa',
    ddi: '1',
    iso2: 'AS',
    citizenship: '',
    name: 'Samoa Americana',
  },
  {
    iso3: 'ATA',
    country: 'Antártida',
    countryToSave: 'Antartida',
    ddi: '672',
    iso2: 'AQ',
    citizenship: '',
    name: 'Antártida',
  },
  {
    iso3: 'ATF',
    country: 'Territórios Franceses do Sul',
    countryToSave: 'French Southern Territories',
    ddi: '-',
    iso2: 'TF',
    citizenship: '',
    name: 'Territórios Franceses do Sul',
  },
  {
    iso3: 'ATG',
    country: 'Antígua e Barbuda',
    countryToSave: 'Antigua e Barbuda',
    ddi: '1',
    iso2: 'AG',
    citizenship: '',
    name: 'Antígua e Barbuda',
  },
  {
    iso3: 'AUS',
    country: 'Austrália',
    countryToSave: 'Australia',
    ddi: '61',
    iso2: 'AU',
    citizenship: 'Australian',
    name: 'Austrália',
  },
  {
    iso3: 'AUT',
    country: 'Áustria',
    countryToSave: 'Austria',
    ddi: '43',
    iso2: 'AT',
    citizenship: 'Austrian',
    name: 'Áustria',
  },
  {
    iso3: 'AZE',
    country: 'Azerbaijão',
    countryToSave: 'Azerbaijan',
    ddi: '994',
    iso2: 'AZ',
    citizenship: '',
    name: 'Azerbaijão',
  },
  {
    iso3: 'BDI',
    country: 'Burundi',
    countryToSave: 'Burundi',
    ddi: '257',
    iso2: 'BI',
    citizenship: '',
    name: 'Burundi',
  },
  {
    iso3: 'BEL',
    country: 'Bélgica',
    countryToSave: 'Belgium',
    ddi: '32',
    iso2: 'BE',
    citizenship: 'Belgian',
    name: 'Bélgica',
  },
  {
    iso3: 'BEN',
    country: 'Benim',
    countryToSave: 'Benim',
    ddi: '229',
    iso2: 'BJ',
    citizenship: '',
    name: 'Benim',
  },
  {
    iso3: 'BES',
    country: 'Bonaire, Santo Eustáquio e Saba',
    countryToSave: 'Bonaire, Santo Eustáquio e Sab',
    ddi: '599',
    iso2: 'BQ',
    citizenship: '',
    name: 'Bonaire, Santo Eustáquio e Saba',
  },
  {
    iso3: 'BFA',
    country: 'Burkina Fasso',
    countryToSave: 'Burkina Fasso',
    ddi: '226',
    iso2: 'BF',
    citizenship: '',
    name: 'Burkina Fasso',
  },
  {
    iso3: 'BGD',
    country: 'Bangladeche',
    countryToSave: 'Bangladesh',
    ddi: '880',
    iso2: 'BD',
    citizenship: '',
    name: 'Bangladeche',
  },
  {
    iso3: 'BGR',
    country: 'Bulgária',
    countryToSave: 'Bulgaria',
    ddi: '359',
    iso2: 'BG',
    citizenship: 'Bulgarian',
    name: 'Bulgária',
  },
  {
    iso3: 'BHR',
    country: 'Barein',
    countryToSave: 'Bahrain',
    ddi: '973',
    iso2: 'BH',
    citizenship: '',
    name: 'Barein',
  },
  {
    iso3: 'BHS',
    country: 'Bahamas',
    countryToSave: 'Bahamas',
    ddi: '1',
    iso2: 'BS',
    citizenship: '',
    name: 'Bahamas',
  },
  {
    iso3: 'BIH',
    country: 'Bósnia e Herzegovina',
    countryToSave: 'Bosnia and Herzegovina',
    ddi: '387',
    iso2: 'BA',
    citizenship: 'Bosnian',
    name: 'Bósnia e Herzegovina',
  },
  {
    iso3: 'BLM',
    country: 'São Bartolomeu',
    countryToSave: 'São Bartolomeu',
    ddi: '590',
    iso2: 'BL',
    citizenship: '',
    name: 'São Bartolomeu',
  },
  {
    iso3: 'BLR',
    country: 'Bielorrússia',
    countryToSave: 'Bielorrússia',
    ddi: '375',
    iso2: 'BY',
    citizenship: 'Belarus',
    name: 'Bielorrússia',
  },
  {
    iso3: 'BLZ',
    country: 'Belize',
    countryToSave: 'Belize',
    ddi: '501',
    iso2: 'BZ',
    citizenship: '',
    name: 'Belize',
  },
  {
    iso3: 'BMU',
    country: 'Bermudas',
    countryToSave: 'Bermuda',
    ddi: '1',
    iso2: 'BM',
    citizenship: '',
    name: 'Bermudas',
  },
  {
    iso3: 'BOL',
    country: 'Bolívia',
    countryToSave: 'Bolívia',
    ddi: '591',
    iso2: 'BO',
    citizenship: 'Bolivian',
    name: 'Bolívia',
  },
  {
    iso3: 'BRA',
    country: 'Brasil',
    countryToSave: 'Brazil',
    ddi: '55',
    iso2: 'BR',
    citizenship: 'Brazilian',
    name: 'Brasil',
  },
  {
    iso3: 'BRB',
    country: 'Barbados',
    countryToSave: 'Barbados',
    ddi: '1',
    iso2: 'BB',
    citizenship: '',
    name: 'Barbados',
  },
  {
    iso3: 'BRN',
    country: 'Brunei',
    countryToSave: 'Brunei',
    ddi: '673',
    iso2: 'BN',
    citizenship: '',
    name: 'Brunei',
  },
  {
    iso3: 'BTN',
    country: 'Butão',
    countryToSave: 'Bhutan',
    ddi: '975',
    iso2: 'BT',
    citizenship: '',
    name: 'Butão',
  },
  {
    iso3: 'BVT',
    country: 'Ilha Bouvet',
    countryToSave: 'Bouvet Island',
    ddi: '-',
    iso2: 'BV',
    citizenship: '',
    name: 'Ilha Bouvet',
  },
  {
    iso3: 'BWA',
    country: 'Botsuana',
    countryToSave: 'Botswana',
    ddi: '267',
    iso2: 'BW',
    citizenship: '',
    name: 'Botsuana',
  },
  {
    iso3: 'CAF',
    country: 'República Centro-Africana',
    countryToSave: 'Central African Republic',
    ddi: '236',
    iso2: 'CF',
    citizenship: 'African',
    name: 'República Centro-Africana',
  },
  {
    iso3: 'CAN',
    country: 'Canadá',
    countryToSave: 'Canada',
    ddi: '1',
    iso2: 'CA',
    citizenship: 'Canadian',
    name: 'Canadá',
  },
  {
    iso3: 'CCK',
    country: 'Ilhas Cocos (Keeling)',
    countryToSave: 'Cocos (Keeling) Islands',
    ddi: '61',
    iso2: 'CC',
    citizenship: '',
    name: 'Ilhas Cocos (Keeling)',
  },
  {
    iso3: 'CHE',
    country: 'Suíça',
    countryToSave: 'Switzerland',
    ddi: '41',
    iso2: 'CH',
    citizenship: 'Swiss',
    name: 'Suíça',
  },
  {
    iso3: 'CHL',
    country: 'Chile',
    countryToSave: 'Chile',
    ddi: '56',
    iso2: 'CL',
    citizenship: 'Chilean',
    name: 'Chile',
  },
  {
    iso3: 'CHN',
    country: 'China',
    countryToSave: 'China',
    ddi: '86',
    iso2: 'CN',
    citizenship: 'Chinese',
    name: 'China',
  },
  {
    iso3: 'CIV',
    country: 'Costa do Marfim',
    countryToSave: "Cote D'ivoire",
    ddi: '225',
    iso2: 'CI',
    citizenship: '',
    name: 'Costa do Marfim',
  },
  {
    iso3: 'CMR',
    country: 'Camarões',
    countryToSave: 'Cameroon',
    ddi: '237',
    iso2: 'CM',
    citizenship: 'Cameron',
    name: 'Camarões',
  },
  {
    iso3: 'COD',
    country: 'Congo, Rep. Democrática',
    countryToSave: 'Congo, The Democratic Republic',
    ddi: '243',
    iso2: 'CD',
    citizenship: 'Congolian',
    name: 'Congo, Rep. Democrática',
  },
  {
    iso3: 'COG',
    country: 'Congo',
    countryToSave: 'Congo',
    ddi: '242',
    iso2: 'CG',
    citizenship: 'Congolian',
    name: 'Congo',
  },
  {
    iso3: 'COK',
    country: 'Ilhas Cook',
    countryToSave: 'Cook Islands',
    ddi: '682',
    iso2: 'CK',
    citizenship: '',
    name: 'Ilhas Cook',
  },
  {
    iso3: 'COL',
    country: 'Colômbia',
    countryToSave: 'Colombia',
    ddi: '57',
    iso2: 'CO',
    citizenship: 'Colombian',
    name: 'Colômbia',
  },
  {
    iso3: 'COM',
    country: 'Comores',
    countryToSave: 'Comoros',
    ddi: '269',
    iso2: 'KM',
    citizenship: '',
    name: 'Comores',
  },
  {
    iso3: 'CPV',
    country: 'Cabo Verde',
    countryToSave: 'Cape Verde',
    ddi: '238',
    iso2: 'CV',
    citizenship: '',
    name: 'Cabo Verde',
  },
  {
    iso3: 'CRI',
    country: 'Costa Rica',
    countryToSave: 'Costa Rica',
    ddi: '506',
    iso2: 'CR',
    citizenship: 'Coasta Rican',
    name: 'Costa Rica',
  },
  {
    iso3: 'CUB',
    country: 'Cuba',
    countryToSave: 'Cuba',
    ddi: '53',
    iso2: 'CU',
    citizenship: 'Cuban',
    name: 'Cuba',
  },
  {
    iso3: 'CUW',
    country: 'Curaçao',
    countryToSave: 'Curaçao',
    ddi: '599',
    iso2: 'CW',
    citizenship: '',
    name: 'Curaçao',
  },
  {
    iso3: 'CXR',
    country: 'Ilha Christmas',
    countryToSave: 'Christmas Island',
    ddi: '61',
    iso2: 'CX',
    citizenship: '',
    name: 'Ilha Christmas',
  },
  {
    iso3: 'CYM',
    country: 'Ilhas Cayman',
    countryToSave: 'Cayman Islands',
    ddi: '1',
    iso2: 'KY',
    citizenship: '',
    name: 'Ilhas Cayman',
  },
  {
    iso3: 'CYP',
    country: 'Chipre',
    countryToSave: 'Chipre',
    ddi: '357',
    iso2: 'CY',
    citizenship: 'Cypriot',
    name: 'Chipre',
  },
  {
    iso3: 'CZE',
    country: 'República Checa',
    countryToSave: 'Czech Republic',
    ddi: '420',
    iso2: 'CZ',
    citizenship: 'Czechoslosvakian',
    name: 'República Checa',
  },
  {
    iso3: 'DEU',
    country: 'Alemanha',
    countryToSave: 'Germany',
    ddi: '49',
    iso2: 'DE',
    citizenship: 'German',
    name: 'Alemanha',
  },
  {
    iso3: 'DJI',
    country: 'Djibuti',
    countryToSave: 'Djibuti',
    ddi: '253',
    iso2: 'DJ',
    citizenship: '',
    name: 'Djibuti',
  },
  {
    iso3: 'DMA',
    country: 'Dominica',
    countryToSave: 'Dominica',
    ddi: '1',
    iso2: 'DM',
    citizenship: '',
    name: 'Dominica',
  },
  {
    iso3: 'DNK',
    country: 'Dinamarca',
    countryToSave: 'Denmark',
    ddi: '45',
    iso2: 'DK',
    citizenship: 'Danish',
    name: 'Dinamarca',
  },
  {
    iso3: 'DOM',
    country: 'República Dominicana',
    countryToSave: 'Dominican Republic',
    ddi: '1',
    iso2: 'DO',
    citizenship: 'Dominican',
    name: 'República Dominicana',
  },
  {
    iso3: 'DZA',
    country: 'Argélia',
    countryToSave: 'Algeria',
    ddi: '213',
    iso2: 'DZ',
    citizenship: 'Algerian',
    name: 'Argélia',
  },
  {
    iso3: 'ECU',
    country: 'Equador',
    countryToSave: 'Ecuador',
    ddi: '593',
    iso2: 'EC',
    citizenship: 'Ecuadorian',
    name: 'Equador',
  },
  {
    iso3: 'EGY',
    country: 'Egito',
    countryToSave: 'Egypt',
    ddi: '20',
    iso2: 'EG',
    citizenship: 'Egyptian',
    name: 'Egito',
  },
  {
    iso3: 'ERI',
    country: 'Eritréia',
    countryToSave: 'Eritrea',
    ddi: '291',
    iso2: 'ER',
    citizenship: '',
    name: 'Eritréia',
  },
  {
    iso3: 'ESH',
    country: 'Saara Ocidental',
    countryToSave: 'Western Sahara',
    ddi: '212',
    iso2: 'EH',
    citizenship: '',
    name: 'Saara Ocidental',
  },
  {
    iso3: 'ESP',
    country: 'Espanha',
    countryToSave: 'Spain',
    ddi: '34',
    iso2: 'ES',
    citizenship: 'Spanish',
    name: 'Espanha',
  },
  {
    iso3: 'EST',
    country: 'Estônia',
    countryToSave: 'Estonia',
    ddi: '372',
    iso2: 'EE',
    citizenship: '',
    name: 'Estônia',
  },
  {
    iso3: 'ETH',
    country: 'Etiópia',
    countryToSave: 'Ethiopia',
    ddi: '251',
    iso2: 'ET',
    citizenship: 'Ethiopian',
    name: 'Etiópia',
  },
  {
    iso3: 'FIN',
    country: 'Finlândia',
    countryToSave: 'Finland',
    ddi: '358',
    iso2: 'FI',
    citizenship: 'Finnish',
    name: 'Finlândia',
  },
  {
    iso3: 'FJI',
    country: 'Fiji',
    countryToSave: 'Fiji',
    ddi: '679',
    iso2: 'FJ',
    citizenship: '',
    name: 'Fiji',
  },
  {
    iso3: 'FLK',
    country: 'Ilhas Falkland (Malvinas)',
    countryToSave: 'Falkland Islands (Malvinas)',
    ddi: '500',
    iso2: 'FK',
    citizenship: '',
    name: 'Ilhas Falkland (Malvinas)',
  },
  {
    iso3: 'FRA',
    country: 'França',
    countryToSave: 'France',
    ddi: '33',
    iso2: 'FR',
    citizenship: 'French',
    name: 'França',
  },
  {
    iso3: 'FRO',
    country: 'Ilhas Faroé',
    countryToSave: 'Ilhas Faroé',
    ddi: '298',
    iso2: 'FO',
    citizenship: '',
    name: 'Ilhas Faroé',
  },
  {
    iso3: 'FSM',
    country: 'Micronésia, Estados Feder. da',
    countryToSave: 'Micronesia, Federated States o',
    ddi: '691',
    iso2: 'FM',
    citizenship: '',
    name: 'Micronésia, Estados Feder. da',
  },
  {
    iso3: 'GAB',
    country: 'Gabão',
    countryToSave: 'Gabon',
    ddi: '241',
    iso2: 'GA',
    citizenship: '',
    name: 'Gabão',
  },
  {
    iso3: 'GBR',
    country: 'Reino Unido',
    countryToSave: 'United Kingdom',
    ddi: '44',
    iso2: 'GB',
    citizenship: 'British',
    name: 'Reino Unido',
  },
  {
    iso3: 'GEO',
    country: 'Geórgia',
    countryToSave: 'Georgia',
    ddi: '995',
    iso2: 'GE',
    citizenship: '',
    name: 'Geórgia',
  },
  {
    iso3: 'GGY',
    country: 'Guernsey',
    countryToSave: 'Guernsey',
    ddi: '44',
    iso2: 'GG',
    citizenship: '',
    name: 'Guernsey',
  },
  {
    iso3: 'GHA',
    country: 'Gana',
    countryToSave: 'Ghana',
    ddi: '233',
    iso2: 'GH',
    citizenship: '',
    name: 'Gana',
  },
  {
    iso3: 'GIB',
    country: 'Gibraltar',
    countryToSave: 'Gibraltar',
    ddi: '350',
    iso2: 'GI',
    citizenship: '',
    name: 'Gibraltar',
  },
  {
    iso3: 'GIN',
    country: 'Guiné',
    countryToSave: 'Guiné',
    ddi: '224',
    iso2: 'GN',
    citizenship: '',
    name: 'Guiné',
  },
  {
    iso3: 'GLP',
    country: 'Guadalupe',
    countryToSave: 'Guadeloupe',
    ddi: '590',
    iso2: 'GP',
    citizenship: '',
    name: 'Guadalupe',
  },
  {
    iso3: 'GMB',
    country: 'Gâmbia',
    countryToSave: 'Gambia',
    ddi: '220',
    iso2: 'GM',
    citizenship: '',
    name: 'Gâmbia',
  },
  {
    iso3: 'GNB',
    country: 'Guiné-Bissau',
    countryToSave: 'Guinea-bissau',
    ddi: '245',
    iso2: 'GW',
    citizenship: '',
    name: 'Guiné-Bissau',
  },
  {
    iso3: 'GNQ',
    country: 'Guiné Equatorial',
    countryToSave: 'Equatorial Guinea',
    ddi: '240',
    iso2: 'GQ',
    citizenship: '',
    name: 'Guiné Equatorial',
  },
  {
    iso3: 'GRC',
    country: 'Grécia',
    countryToSave: 'Greece',
    ddi: '30',
    iso2: 'GR',
    citizenship: 'Greek',
    name: 'Grécia',
  },
  {
    iso3: 'GRD',
    country: 'Grenada',
    countryToSave: 'Grenada',
    ddi: '1',
    iso2: 'GD',
    citizenship: '',
    name: 'Grenada',
  },
  {
    iso3: 'GRL',
    country: 'Groelândia',
    countryToSave: 'Greenland',
    ddi: '299',
    iso2: 'GL',
    citizenship: '',
    name: 'Groelândia',
  },
  {
    iso3: 'GTM',
    country: 'Guatemala',
    countryToSave: 'Guatemala',
    ddi: '502',
    iso2: 'GT',
    citizenship: 'Guatemalan',
    name: 'Guatemala',
  },
  {
    iso3: 'GUF',
    country: 'Guiana Francesa',
    countryToSave: 'French Guiana',
    ddi: '594',
    iso2: 'GF',
    citizenship: '',
    name: 'Guiana Francesa',
  },
  {
    iso3: 'GUM',
    country: 'Guam',
    countryToSave: 'Guam',
    ddi: '1',
    iso2: 'GU',
    citizenship: '',
    name: 'Guam',
  },
  {
    iso3: 'GUY',
    country: 'Guiana',
    countryToSave: 'Guyana',
    ddi: '592',
    iso2: 'GY',
    citizenship: '',
    name: 'Guiana',
  },
  {
    iso3: 'HKG',
    country: 'Hong Kong',
    countryToSave: 'Hong Kong',
    ddi: '852',
    iso2: 'HK',
    citizenship: '',
    name: 'Hong Kong',
  },
  {
    iso3: 'HMD',
    country: 'Ilhas Heard e Mc Donald',
    countryToSave: 'Heard and Mc Donald Islands',
    ddi: '-',
    iso2: 'HM',
    citizenship: '',
    name: 'Ilhas Heard e Mc Donald',
  },
  {
    iso3: 'HND',
    country: 'Honduras',
    countryToSave: 'Honduras',
    ddi: '504',
    iso2: 'HN',
    citizenship: 'Honduran',
    name: 'Honduras',
  },
  {
    iso3: 'HRV',
    country: 'Croácia',
    countryToSave: 'Croatia',
    ddi: '385',
    iso2: 'HR',
    citizenship: 'Croatian',
    name: 'Croácia',
  },
  {
    iso3: 'HTI',
    country: 'Haiti',
    countryToSave: 'Haiti',
    ddi: '509',
    iso2: 'HT',
    citizenship: 'Haitian',
    name: 'Haiti',
  },
  {
    iso3: 'HUN',
    country: 'Hungria',
    countryToSave: 'Hungary',
    ddi: '36',
    iso2: 'HU',
    citizenship: 'Hungarian',
    name: 'Hungria',
  },
  {
    iso3: 'IDN',
    country: 'Indonésia',
    countryToSave: 'Indonesia',
    ddi: '62',
    iso2: 'ID',
    citizenship: 'Indonesian',
    name: 'Indonésia',
  },
  {
    iso3: 'IMN',
    country: 'Ilha de Man',
    countryToSave: 'Ilha de Man',
    ddi: '44',
    iso2: 'IM',
    citizenship: '',
    name: 'Ilha de Man',
  },
  {
    iso3: 'IND',
    country: 'Índia',
    countryToSave: 'Índia',
    ddi: '91',
    iso2: 'IN',
    citizenship: 'Indian',
    name: 'Índia',
  },
  {
    iso3: 'IOT',
    country: 'Território Britânico do Oceano Índico',
    countryToSave: 'Território Britânico do Oceano Índico',
    ddi: '246',
    iso2: 'IO',
    citizenship: 'British',
    name: 'Território Britânico do Oceano Índico',
  },
  {
    iso3: 'IRL',
    country: 'Irlanda',
    countryToSave: 'Ireland',
    ddi: '353',
    iso2: 'IE',
    citizenship: '',
    name: 'Irlanda',
  },
  {
    iso3: 'IRN',
    country: 'Irã (República Islâmica do)',
    countryToSave: 'Iran (Islamic Republic of)',
    ddi: '98',
    iso2: 'IR',
    citizenship: 'Iranian',
    name: 'Irã (República Islâmica do)',
  },
  {
    iso3: 'IRQ',
    country: 'Iraque',
    countryToSave: 'Iraq',
    ddi: '964',
    iso2: 'IQ',
    citizenship: 'Iraqi',
    name: 'Iraque',
  },
  {
    iso3: 'ISL',
    country: 'Islândia',
    countryToSave: 'Iceland',
    ddi: '354',
    iso2: 'IS',
    citizenship: 'Icelander',
    name: 'Islândia',
  },
  {
    iso3: 'ISR',
    country: 'Israel',
    countryToSave: 'Israel',
    ddi: '972',
    iso2: 'IL',
    citizenship: 'Israeli',
    name: 'Israel',
  },
  {
    iso3: 'ITA',
    country: 'Itália',
    countryToSave: 'Italy',
    ddi: '39',
    iso2: 'IT',
    citizenship: 'Italian',
    name: 'Itália',
  },
  {
    iso3: 'JAM',
    country: 'Jamaica',
    countryToSave: 'Jamaica',
    ddi: '1',
    iso2: 'JM',
    citizenship: 'Jamaican',
    name: 'Jamaica',
  },
  {
    iso3: 'JEY',
    country: 'Jersey',
    countryToSave: 'Jersey',
    ddi: '44',
    iso2: 'JE',
    citizenship: '',
    name: 'Jersey',
  },
  {
    iso3: 'JOR',
    country: 'Jordânia',
    countryToSave: 'Jordânia',
    ddi: '962',
    iso2: 'JO',
    citizenship: '',
    name: 'Jordânia',
  },
  {
    iso3: 'JPN',
    country: 'Japão',
    countryToSave: 'Japan',
    ddi: '81',
    iso2: 'JP',
    citizenship: 'Japanese',
    name: 'Japão',
  },
  {
    iso3: 'KAZ',
    country: 'Cazaquistão',
    countryToSave: 'Kazakhstan',
    ddi: '7',
    iso2: 'KZ',
    citizenship: '',
    name: 'Cazaquistão',
  },
  {
    iso3: 'KEN',
    country: 'Quênia',
    countryToSave: 'Kenya',
    ddi: '254',
    iso2: 'KE',
    citizenship: 'Kenyan',
    name: 'Quênia',
  },
  {
    iso3: 'KGZ',
    country: 'Quirguistão',
    countryToSave: 'Kyrgyzstan',
    ddi: '996',
    iso2: 'KG',
    citizenship: '',
    name: 'Quirguistão',
  },
  {
    iso3: 'KHM',
    country: 'Camboja',
    countryToSave: 'Cambodia',
    ddi: '855',
    iso2: 'KH',
    citizenship: 'Cambodian',
    name: 'Camboja',
  },
  {
    iso3: 'KIR',
    country: 'Kiribati',
    countryToSave: 'Kiribati',
    ddi: '686',
    iso2: 'KI',
    citizenship: '',
    name: 'Kiribati',
  },
  {
    iso3: 'KNA',
    country: 'São Cristóvão e Névis',
    countryToSave: 'São Cristóvão e Névis',
    ddi: '1',
    iso2: 'KN',
    citizenship: '',
    name: 'São Cristóvão e Névis',
  },
  {
    iso3: 'KOR',
    country: 'Coréia do Sul',
    countryToSave: 'Korea',
    ddi: '82',
    iso2: 'KR',
    citizenship: 'South Korean',
    name: 'Coréia do Sul',
  },
  {
    iso3: 'KWT',
    country: 'Kuwait',
    countryToSave: 'Kuwait',
    ddi: '965',
    iso2: 'KW',
    citizenship: 'Kuwaiti',
    name: 'Kuwait',
  },
  {
    iso3: 'LAO',
    country: 'Laos, Rep. Democr. Popular do',
    countryToSave: 'Laos, Rep. Democr. Popular do',
    ddi: '856',
    iso2: 'LA',
    citizenship: '',
    name: 'Laos, Rep. Democr. Popular do',
  },
  {
    iso3: 'LBN',
    country: 'Líbano',
    countryToSave: 'Lebanon',
    ddi: '961',
    iso2: 'LB',
    citizenship: 'Lebanese',
    name: 'Líbano',
  },
  {
    iso3: 'LBR',
    country: 'Libéria',
    countryToSave: 'Liberia',
    ddi: '231',
    iso2: 'LR',
    citizenship: '',
    name: 'Libéria',
  },
  {
    iso3: 'LBY',
    country: 'Líbia',
    countryToSave: 'Líbia',
    ddi: '218',
    iso2: 'LY',
    citizenship: 'Libyan',
    name: 'Líbia',
  },
  {
    iso3: 'LCA',
    country: 'Santa Lúcia',
    countryToSave: 'Santa Lúcia',
    ddi: '1',
    iso2: 'LC',
    citizenship: '',
    name: 'Santa Lúcia',
  },
  {
    iso3: 'LIE',
    country: 'Liechtenstein',
    countryToSave: 'Liechtenstein',
    ddi: '423',
    iso2: 'LI',
    citizenship: '',
    name: 'Liechtenstein',
  },
  {
    iso3: 'LKA',
    country: 'Sri Lanka',
    countryToSave: 'Sri Lanka',
    ddi: '94',
    iso2: 'LK',
    citizenship: '',
    name: 'Sri Lanka',
  },
  {
    iso3: 'LSO',
    country: 'Lesoto',
    countryToSave: 'Lesotho',
    ddi: '266',
    iso2: 'LS',
    citizenship: '',
    name: 'Lesoto',
  },
  {
    iso3: 'LTU',
    country: 'Lituânia',
    countryToSave: 'Lithuania',
    ddi: '370',
    iso2: 'LT',
    citizenship: 'Lituan',
    name: 'Lituânia',
  },
  {
    iso3: 'LUX',
    country: 'Luxemburgo',
    countryToSave: 'Luxembourg',
    ddi: '352',
    iso2: 'LU',
    citizenship: '',
    name: 'Luxemburgo',
  },
  {
    iso3: 'LVA',
    country: 'Letônia',
    countryToSave: 'Latvia',
    ddi: '371',
    iso2: 'LV',
    citizenship: 'Latvian',
    name: 'Letônia',
  },
  {
    iso3: 'MAC',
    country: 'Macau',
    countryToSave: 'Macau',
    ddi: '853',
    iso2: 'MO',
    citizenship: '',
    name: 'Macau',
  },
  {
    iso3: 'MAF',
    country: 'São Martinho (França)',
    countryToSave: 'São Martinho (França)',
    ddi: '590',
    iso2: 'MF',
    citizenship: '',
    name: 'São Martinho (França)',
  },
  {
    iso3: 'MAR',
    country: 'Marrocos',
    countryToSave: 'Morocco',
    ddi: '212',
    iso2: 'MA',
    citizenship: 'Moroccan',
    name: 'Marrocos',
  },
  {
    iso3: 'MCO',
    country: 'Mônaco',
    countryToSave: 'Monaco',
    ddi: '377',
    iso2: 'MC',
    citizenship: '',
    name: 'Mônaco',
  },
  {
    iso3: 'MDA',
    country: 'Moldova, República da',
    countryToSave: 'Moldova, Republic of',
    ddi: '373',
    iso2: 'MD',
    citizenship: '',
    name: 'Moldova, República da',
  },
  {
    iso3: 'MDG',
    country: 'Madagáscar',
    countryToSave: 'Madagáscar',
    ddi: '261',
    iso2: 'MG',
    citizenship: '',
    name: 'Madagáscar',
  },
  {
    iso3: 'MDV',
    country: 'Maldivas',
    countryToSave: 'Maldives',
    ddi: '960',
    iso2: 'MV',
    citizenship: '',
    name: 'Maldivas',
  },
  {
    iso3: 'MEX',
    country: 'México',
    countryToSave: 'Mexico',
    ddi: '52',
    iso2: 'MX',
    citizenship: 'Mexican',
    name: 'México',
  },
  {
    iso3: 'MHL',
    country: 'Ilhas Marshall',
    countryToSave: 'Marshall Islands',
    ddi: '692',
    iso2: 'MH',
    citizenship: '',
    name: 'Ilhas Marshall',
  },
  {
    iso3: 'MKD',
    country: 'República da Macedônia',
    countryToSave: 'República da Macedônia',
    ddi: '389',
    iso2: 'MK',
    citizenship: '',
    name: 'República da Macedônia',
  },
  {
    iso3: 'MLI',
    country: 'Mali',
    countryToSave: 'Mali',
    ddi: '223',
    iso2: 'ML',
    citizenship: '',
    name: 'Mali',
  },
  {
    iso3: 'MLT',
    country: 'Malta',
    countryToSave: 'Malta',
    ddi: '356',
    iso2: 'MT',
    citizenship: '',
    name: 'Malta',
  },
  {
    iso3: 'MMR',
    country: 'Myanmar',
    countryToSave: 'Myanmar',
    ddi: '95',
    iso2: 'MM',
    citizenship: '',
    name: 'Myanmar',
  },
  {
    iso3: 'MNE',
    country: 'Montenegro',
    countryToSave: 'Montenegro',
    ddi: '382',
    iso2: 'ME',
    citizenship: '',
    name: 'Montenegro',
  },
  {
    iso3: 'MNG',
    country: 'Mongólia',
    countryToSave: 'Mongolia',
    ddi: '976',
    iso2: 'MN',
    citizenship: 'Mongolian',
    name: 'Mongólia',
  },
  {
    iso3: 'MNP',
    country: 'Ilhas Mariana do Norte',
    countryToSave: 'Northern Mariana Islands',
    ddi: '1',
    iso2: 'MP',
    citizenship: '',
    name: 'Ilhas Mariana do Norte',
  },
  {
    iso3: 'MOZ',
    country: 'Moçambique',
    countryToSave: 'Mozambique',
    ddi: '258',
    iso2: 'MZ',
    citizenship: '',
    name: 'Moçambique',
  },
  {
    iso3: 'MRT',
    country: 'Mauritânia',
    countryToSave: 'Mauritania',
    ddi: '222',
    iso2: 'MR',
    citizenship: '',
    name: 'Mauritânia',
  },
  {
    iso3: 'MSR',
    country: 'Montserrat',
    countryToSave: 'Montserrat',
    ddi: '1',
    iso2: 'MS',
    citizenship: '',
    name: 'Montserrat',
  },
  {
    iso3: 'MTQ',
    country: 'Martinica',
    countryToSave: 'Martinique',
    ddi: '596',
    iso2: 'MQ',
    citizenship: '',
    name: 'Martinica',
  },
  {
    iso3: 'MUS',
    country: 'Ilhas Mauricius',
    countryToSave: 'Mauritius',
    ddi: '230',
    iso2: 'MU',
    citizenship: '',
    name: 'Ilhas Mauricius',
  },
  {
    iso3: 'MWI',
    country: 'Malawi',
    countryToSave: 'Malawi',
    ddi: '265',
    iso2: 'MW',
    citizenship: '',
    name: 'Malawi',
  },
  {
    iso3: 'MYS',
    country: 'Malásia',
    countryToSave: 'Malaysia',
    ddi: '60',
    iso2: 'MY',
    citizenship: 'Malaysian',
    name: 'Malásia',
  },
  {
    iso3: 'MYT',
    country: 'Mayotte',
    countryToSave: 'Mayotte',
    ddi: '262',
    iso2: 'YT',
    citizenship: '',
    name: 'Mayotte',
  },
  {
    iso3: 'NAM',
    country: 'Namíbia',
    countryToSave: 'Namibia',
    ddi: '264',
    iso2: 'NA',
    citizenship: '',
    name: 'Namíbia',
  },
  {
    iso3: 'NCL',
    country: 'Nova Caledônia',
    countryToSave: 'New Caledonia',
    ddi: '687',
    iso2: 'NC',
    citizenship: '',
    name: 'Nova Caledônia',
  },
  {
    iso3: 'NER',
    country: 'Níger',
    countryToSave: 'Níger',
    ddi: '227',
    iso2: 'NE',
    name: 'Níger',
  },
  {
    iso3: 'NFK',
    country: 'Ilha Norfolk',
    countryToSave: 'Norfolk Island',
    ddi: '672',
    iso2: 'NF',
    citizenship: '',
    name: 'Ilha Norfolk',
  },
  {
    iso3: 'NGA',
    country: 'Nigéria',
    countryToSave: 'Nigeria',
    ddi: '234',
    iso2: 'NG',
    citizenship: 'Nigerian',
    name: 'Nigéria',
  },
  {
    iso3: 'NIC',
    country: 'Nicarágua',
    countryToSave: 'Nicaragua',
    ddi: '505',
    iso2: 'NI',
    citizenship: 'Nicaraguan',
    name: 'Nicarágua',
  },
  {
    iso3: 'NIU',
    country: 'Niue',
    countryToSave: 'Niue',
    ddi: '683',
    iso2: 'NU',
    citizenship: '',
    name: 'Niue',
  },
  {
    iso3: 'NLD',
    country: 'Holanda',
    countryToSave: 'Netherlands',
    ddi: '31',
    iso2: 'NL',
    citizenship: 'Dutch',
    name: 'Holanda',
  },
  {
    iso3: 'NOR',
    country: 'Noruega',
    countryToSave: 'Norway',
    ddi: '47',
    iso2: 'NO',
    citizenship: 'Norwegian',
    name: 'Noruega',
  },
  {
    iso3: 'NPL',
    country: 'Nepal',
    countryToSave: 'Nepal',
    ddi: '977',
    iso2: 'NP',
    citizenship: '',
    name: 'Nepal',
  },
  {
    iso3: 'NRU',
    country: 'Nauru',
    countryToSave: 'Nauru',
    ddi: '674',
    iso2: 'NR',
    citizenship: '',
    name: 'Nauru',
  },
  {
    iso3: 'NZL',
    country: 'Nova Zelândia',
    countryToSave: 'New Zealand',
    ddi: '64',
    iso2: 'NZ',
    citizenship: 'New Zeland',
    name: 'Nova Zelândia',
  },
  {
    iso3: 'OMN',
    country: 'Omã',
    countryToSave: 'Oman',
    ddi: '968',
    iso2: 'OM',
    citizenship: '',
    name: 'Omã',
  },
  {
    iso3: 'PAK',
    country: 'Paquistão',
    countryToSave: 'Pakistan',
    ddi: '92',
    iso2: 'PK',
    citizenship: 'Pakistani',
    name: 'Paquistão',
  },
  {
    iso3: 'PAN',
    country: 'Panamá',
    countryToSave: 'Panama',
    ddi: '507',
    iso2: 'PA',
    citizenship: 'Panama',
    name: 'Panamá',
  },
  {
    iso3: 'PCN',
    country: 'Pitcairn',
    countryToSave: 'Pitcairn',
    ddi: '870',
    iso2: 'PN',
    citizenship: '',
    name: 'Pitcairn',
  },
  {
    iso3: 'PER',
    country: 'Peru',
    countryToSave: 'Peru',
    ddi: '51',
    iso2: 'PE',
    citizenship: 'Peruvian',
    name: 'Peru',
  },
  {
    iso3: 'PHL',
    country: 'Filipinas',
    countryToSave: 'Philippines',
    ddi: '63',
    iso2: 'PH',
    citizenship: 'Philippine',
    name: 'Filipinas',
  },
  {
    iso3: 'PLW',
    country: 'Palau',
    countryToSave: 'Palau',
    ddi: '680',
    iso2: 'PW',
    citizenship: '',
    name: 'Palau',
  },
  {
    iso3: 'PNG',
    country: 'Papua-Nova Guiné',
    countryToSave: 'Papua-Nova Guiné',
    ddi: '675',
    iso2: 'PG',
    citizenship: '',
    name: 'Papua-Nova Guiné',
  },
  {
    iso3: 'POL',
    country: 'Polônia',
    countryToSave: 'Poland',
    ddi: '48',
    iso2: 'PL',
    citizenship: 'Polish',
    name: 'Polônia',
  },
  {
    iso3: 'PRI',
    country: 'Porto Rico',
    countryToSave: '',
    ddi: '1',
    iso2: 'PR',
    citizenship: 'Porto Rico',
    name: 'Porto Rico',
  },
  {
    iso3: 'PRK',
    country: 'Coréia, R. Popular Democrática',
    countryToSave: '',
    ddi: '850',
    iso2: 'KP',
    citizenship: '',
    name: 'Coréia, R. Popular Democrática',
  },
  {
    iso3: 'PRT',
    country: 'Portugal',
    countryToSave: 'Portugal',
    ddi: '351',
    iso2: 'PT',
    citizenship: 'Portuguese',
    name: 'Portugal',
  },
  {
    iso3: 'PRY',
    country: 'Paraguai',
    countryToSave: 'Paraguay',
    ddi: '595',
    iso2: 'PY',
    citizenship: 'Paraguayan',
    name: 'Paraguai',
  },
  {
    iso3: 'PSE',
    country: 'Palestina',
    countryToSave: 'Palestine',
    ddi: '970',
    iso2: 'PS',
    citizenship: '',
    name: 'Palestina',
  },
  {
    iso3: 'PYF',
    country: 'Polinésia Francesa',
    countryToSave: 'French Polynesia',
    ddi: '689',
    iso2: 'PF',
    citizenship: '',
    name: 'Polinésia Francesa',
  },
  {
    iso3: 'QAT',
    country: 'Qatar',
    countryToSave: 'Qatar',
    ddi: '974',
    iso2: 'QA',
    citizenship: '',
    name: 'Qatar',
  },
  {
    iso3: 'REU',
    country: 'Reunião',
    countryToSave: 'Reunion',
    ddi: '262',
    iso2: 'RE',
    citizenship: '',
    name: 'Reunião',
  },
  {
    iso3: 'ROU',
    country: 'Romênia',
    countryToSave: 'Romania',
    ddi: '40',
    iso2: 'RO',
    citizenship: 'Rumanian',
    name: 'Romênia',
  },
  {
    iso3: 'RUS',
    country: 'Rússia',
    countryToSave: 'Rússia',
    ddi: '7',
    iso2: 'RU',
    citizenship: 'Russian',
    name: 'Rússia',
  },
  {
    iso3: 'RWA',
    country: 'Ruanda',
    countryToSave: 'Rwanda',
    ddi: '250',
    iso2: 'RW',
    citizenship: '',
    name: 'Ruanda',
  },
  {
    iso3: 'SAU',
    country: 'Arábia Saudita',
    countryToSave: 'Saudi Arabia',
    ddi: '966',
    iso2: 'SA',
    citizenship: 'Saudi Arabian',
    name: 'Arábia Saudita',
  },
  {
    iso3: 'SDN',
    country: 'Sudão',
    countryToSave: 'Sudan',
    ddi: '249',
    iso2: 'SD',
    citizenship: 'Sudanese',
    name: 'Sudão',
  },
  {
    iso3: 'SEN',
    country: 'Senegal',
    countryToSave: 'Senegal',
    ddi: '221',
    iso2: 'SN',
    citizenship: 'Senegalian',
    name: 'Senegal',
  },
  {
    iso3: 'SGP',
    country: 'Singapura',
    countryToSave: 'Singapura',
    ddi: '65',
    iso2: 'SG',
    citizenship: '',
    name: 'Singapura',
  },
  {
    iso3: 'SGS',
    country: 'Ilhas Geórgia do Sul e Sandwich do Sul',
    countryToSave: 'Ilhas Geórgia do Sul e Sandwich do Sul',
    ddi: '-',
    iso2: 'GS',
    citizenship: '',
    name: 'Ilhas Geórgia do Sul e Sandwich do Sul',
  },
  {
    iso3: 'SHN',
    country: 'Santa Helena',
    countryToSave: 'St. Helena',
    ddi: '290',
    iso2: 'SH',
    citizenship: '',
    name: 'Santa Helena',
  },
  {
    iso3: 'SJM',
    country: 'Ilhas Svalbard e Jan Mayen',
    countryToSave: 'Svalbard and Jan Mayen Islands',
    ddi: '47',
    iso2: 'SJ',
    citizenship: '',
    name: 'Ilhas Svalbard e Jan Mayen',
  },
  {
    iso3: 'SLB',
    country: 'Ilhas Solomon',
    countryToSave: 'Solomon Islands',
    ddi: '677',
    iso2: 'SB',
    citizenship: '',
    name: 'Ilhas Solomon',
  },
  {
    iso3: 'SLE',
    country: 'Serra Leoa',
    countryToSave: 'Sierra Leone',
    ddi: '232',
    iso2: 'SL',
    citizenship: '',
    name: 'Serra Leoa',
  },
  {
    iso3: 'SLV',
    country: 'El Salvador',
    countryToSave: 'El Salvador',
    ddi: '503',
    iso2: 'SV',
    citizenship: 'Salvadorean',
    name: 'El Salvador',
  },
  {
    iso3: 'SMR',
    country: 'San Marino',
    countryToSave: 'San Marino',
    ddi: '378',
    iso2: 'SM',
    citizenship: 'Sanmarinense',
    name: 'San Marino',
  },
  {
    iso3: 'SOM',
    country: 'Somália',
    countryToSave: 'Somalia',
    ddi: '252',
    iso2: 'SO',
    citizenship: 'Somalian',
    name: 'Somália',
  },
  {
    iso3: 'SPM',
    country: 'St. Pierre e Miquelon',
    countryToSave: 'St. Pierre and Miquelon',
    ddi: '508',
    iso2: 'PM',
    citizenship: '',
    name: 'St. Pierre e Miquelon',
  },
  {
    iso3: 'SRB',
    country: 'Sérvia',
    countryToSave: 'Serbia',
    ddi: '381',
    iso2: 'RS',
    citizenship: '',
    name: 'Sérvia',
  },
  {
    iso3: 'SSD',
    country: 'Sudão do Sul',
    countryToSave: 'Sudão do Sul',
    ddi: '211',
    iso2: 'SS',
    citizenship: '',
    name: 'Sudão do Sul',
  },
  {
    iso3: 'STP',
    country: 'São Tomé e Príncipe',
    countryToSave: 'São Tomé e Príncipe',
    ddi: '239',
    iso2: 'ST',
    citizenship: '',
    name: 'São Tomé e Príncipe',
  },
  {
    iso3: 'SUR',
    country: 'Suriname',
    countryToSave: 'Suriname',
    ddi: '597',
    iso2: 'SR',
    citizenship: '',
    name: 'Suriname',
  },
  {
    iso3: 'SVK',
    country: 'Eslováquia (Repúblic.Eslovaca)',
    countryToSave: 'Slovakia (Slovak Republic)',
    ddi: '421',
    iso2: 'SK',
    citizenship: 'Slovakian',
    name: 'Eslováquia (Repúblic.Eslovaca)',
  },
  {
    iso3: 'SVN',
    country: 'Eslovênia',
    countryToSave: 'Slovenia',
    ddi: '386',
    iso2: 'SI',
    citizenship: 'Slovenian',
    name: 'Eslovênia',
  },
  {
    iso3: 'SWE',
    country: 'Suécia',
    countryToSave: 'Sweden',
    ddi: '46',
    iso2: 'SE',
    citizenship: 'Swedish',
    name: 'Suécia',
  },
  {
    iso3: 'SWZ',
    country: 'Suazilândia',
    countryToSave: 'Sweden',
    ddi: '268',
    iso2: 'SZ',
    citizenship: '',
    name: 'Suazilândia',
  },
  {
    iso3: 'SXM',
    country: 'São Martinho (Países Baixos)',
    countryToSave: 'São Martinho (Países Baixos)',
    ddi: '599',
    iso2: 'SX',
    citizenship: 'Dutch',
    name: 'São Martinho (Países Baixos)',
  },
  {
    iso3: 'SYC',
    country: 'Seychelles',
    countryToSave: 'Seychelles',
    ddi: '248',
    iso2: 'SC',
    citizenship: '',
    name: 'Seychelles',
  },
  {
    iso3: 'SYR',
    country: 'Síria',
    countryToSave: 'Síria',
    ddi: '963',
    iso2: 'SY',
    citizenship: 'Syrian',
    name: 'Síria',
  },
  {
    iso3: 'TCA',
    country: 'Turks e Caicos',
    countryToSave: 'Turks e Caicos',
    ddi: '1',
    iso2: 'TC',
    citizenship: '',
    name: 'Turks e Caicos',
  },
  {
    iso3: 'TCD',
    country: 'Chade',
    countryToSave: 'Chad',
    ddi: '235',
    iso2: 'TD',
    citizenship: '',
    name: 'Chade',
  },
  {
    iso3: 'TGO',
    country: 'Togo',
    countryToSave: 'Togo',
    ddi: '228',
    iso2: 'TG',
    citizenship: 'Togolian',
    name: 'Togo',
  },
  {
    iso3: 'THA',
    country: 'Tailândia',
    countryToSave: 'Thailand',
    ddi: '66',
    iso2: 'TH',
    citizenship: 'Thailand',
    name: 'Tailândia',
  },
  {
    iso3: 'TJK',
    country: 'Tajiquistão',
    countryToSave: 'Tajikistan',
    ddi: '992',
    iso2: 'TJ',
    citizenship: '',
    name: 'Tajiquistão',
  },
  {
    iso3: 'TKL',
    country: 'Toquelau',
    countryToSave: 'Toquelau',
    ddi: '690',
    iso2: 'TK',
    citizenship: '',
    name: 'Toquelau',
  },
  {
    iso3: 'TKM',
    country: 'Turcomenistão',
    countryToSave: 'Turkmenistan',
    ddi: '993',
    iso2: 'TM',
    citizenship: '',
    name: 'Turcomenistão',
  },
  {
    iso3: 'TLS',
    country: 'Timor-Leste',
    countryToSave: 'Timor-Leste',
    ddi: '670',
    iso2: 'TL',
    citizenship: '',
    name: 'Timor-Leste',
  },
  {
    iso3: 'TON',
    country: 'Tonga',
    countryToSave: 'Tonga',
    ddi: '676',
    iso2: 'TO',
    citizenship: '',
    name: 'Tonga',
  },
  {
    iso3: 'TTO',
    country: 'Trindade e Tobago',
    countryToSave: 'Trindade e Tobago',
    ddi: '1',
    iso2: 'TT',
    citizenship: '',
    name: 'Trindade e Tobago',
  },
  {
    iso3: 'TUN',
    country: 'Tunísia',
    countryToSave: 'Tunisia',
    ddi: '216',
    iso2: 'TN',
    citizenship: '',
    name: 'Tunísia',
  },
  {
    iso3: 'TUR',
    country: 'Turquia',
    countryToSave: 'Turkey',
    ddi: '90',
    iso2: 'TR',
    citizenship: 'Turkish',
    name: 'Turquia',
  },
  {
    iso3: 'TUV',
    country: 'Tuvalu',
    countryToSave: 'Tuvalu',
    ddi: '688',
    iso2: 'TV',
    citizenship: '',
    name: 'Tuvalu',
  },
  {
    iso3: 'TWN',
    country: 'Taiwan',
    countryToSave: 'Taiwan',
    ddi: '886',
    iso2: 'TW',
    citizenship: 'Taiwanese',
    name: 'Taiwan',
  },
  {
    iso3: 'TZA',
    country: 'Tanzânia, República Unida da',
    countryToSave: 'Tanzania, United Republic of',
    ddi: '255',
    iso2: 'TZ',
    citizenship: 'Tanzanian',
    name: 'Tanzânia, República Unida da',
  },
  {
    iso3: 'UGA',
    country: 'Uganda',
    countryToSave: 'Uganda',
    ddi: '256',
    iso2: 'UG',
    citizenship: '',
    name: 'Uganda',
  },
  {
    iso3: 'UKR',
    country: 'Ucrânia',
    countryToSave: 'Ukraine',
    ddi: '380',
    iso2: 'UA',
    citizenship: 'Ukranian',
    name: 'Ucrânia',
  },
  {
    iso3: 'UMI',
    country: 'Ilhas Menores Distantes dos Estados Unidos',
    countryToSave: 'Ilhas Menores Distantes dos Estados Unidos',
    ddi: '1',
    iso2: 'UM',
    citizenship: 'American',
    name: 'Ilhas Menores Distantes dos Estados Unidos',
  },
  {
    iso3: 'URY',
    country: 'Uruguai',
    countryToSave: 'Uruguay',
    ddi: '598',
    iso2: 'UY',
    citizenship: 'Uruguayan',
    name: 'Uruguai',
  },
  {
    iso3: 'USA',
    country: 'Estados Unidos',
    countryToSave: 'USA',
    ddi: '1',
    iso2: 'US',
    citizenship: 'American',
    name: 'Estados Unidos',
  },
  {
    iso3: 'UZB',
    country: 'Usbequistão',
    countryToSave: 'Uzbekistan',
    ddi: '998',
    iso2: 'UZ',
    citizenship: '',
    name: 'Usbequistão',
  },
  {
    iso3: 'VAT',
    country: 'Vaticano',
    countryToSave: 'Vatican',
    ddi: '379',
    iso2: 'VA',
    citizenship: '',
    name: 'Vaticano',
  },
  {
    iso3: 'VCT',
    country: 'São Vicente e Granadinas',
    countryToSave: 'Saint Vincent and the Grenadin',
    ddi: '1',
    iso2: 'VC',
    citizenship: '',
    name: 'São Vicente e Granadinas',
  },
  {
    iso3: 'VEN',
    country: 'Venezuela',
    countryToSave: 'Venezuela',
    ddi: '58',
    iso2: 'VE',
    citizenship: 'Venezuelan',
    name: 'Venezuela',
  },
  {
    iso3: 'VGB',
    country: 'Ilhas Virgens (Britânicas)',
    countryToSave: 'Virgin Islands (British)',
    ddi: '1',
    iso2: 'VG',
    citizenship: '',
    name: 'Ilhas Virgens (Britânicas)',
  },
  {
    iso3: 'VIR',
    country: 'Ilhas Virgens (EUA)',
    countryToSave: 'Virgin Islands (U.S.)',
    ddi: '1',
    iso2: 'VI',
    citizenship: '',
    name: 'Ilhas Virgens (EUA)',
  },
  {
    iso3: 'VNM',
    country: 'Vietnã',
    countryToSave: 'Viet Nam',
    ddi: '84',
    iso2: 'VN',
    citizenship: 'Vietnamese',
    name: 'Vietnã',
  },
  {
    iso3: 'VUT',
    country: 'Vanuatu',
    countryToSave: 'Vanuatu',
    ddi: '678',
    iso2: 'VU',
    citizenship: '',
    name: 'Vanuatu',
  },
  {
    iso3: 'WLF',
    country: 'Wallis e Futuna',
    countryToSave: 'Wallis and Futuna Islands',
    ddi: '681',
    iso2: 'WF',
    citizenship: '',
    name: 'Wallis e Futuna',
  },
  {
    iso3: 'WSM',
    country: 'Samoa',
    countryToSave: 'Samoa',
    ddi: '685',
    iso2: 'WS',
    citizenship: '',
    name: 'Samoa',
  },
  {
    iso3: 'YEM',
    country: 'Iemen',
    countryToSave: 'Yemen',
    ddi: '967',
    iso2: 'YE',
    citizenship: '',
    name: 'Iemen',
  },
  {
    iso3: 'ZAF',
    country: 'África do Sul',
    countryToSave: 'South Africa',
    ddi: '27',
    iso2: 'ZA',
    citizenship: 'African',
    name: 'África do Sul',
  },
  {
    iso3: 'ZMB',
    country: 'Zâmbia',
    countryToSave: 'Zambia',
    ddi: '260',
    iso2: 'ZM',
    citizenship: '',
    name: 'Zâmbia',
  },
  {
    iso3: 'ZWE',
    country: 'Zimbabue',
    countryToSave: 'Zimbabwe',
    ddi: '263',
    iso2: 'ZW',
    citizenship: '',
    name: 'Zimbabue',
  },
];
